<template>
  <a-drawer
    class="account__edit"
    :visible="visible"
    :width="650"
    :title="`${account ? '编辑' : '新建'}账号`"
    @ok="handleOk"
    @cancel="handleCancel"
    @close="handleCancel"
    :mask-closable="false"
    destroy-on-close
  >
    <a-form
      class="account__edit__form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      :form="form"
    >
      <template v-if="!account || (account && accountDetail)">
        <a-form-item label="账号">
          <a-input
            v-decorator="[
              'userName',
              {
                initialValue: account ? accountDetail.userName : undefined,
                rules: [
                  {
                    required: true,
                    message: '请输入账号',
                  },
                ],
              },
            ]"
            placeholder="账号"
            autocomplete="off"
            :disabled="!!account"
          />
        </a-form-item>
        <a-form-item label="姓名">
          <a-input
            v-decorator="[
              'fullName',
              {
                initialValue: account ? accountDetail.fullName : undefined,
                rules: [
                  {
                    required: true,
                    message: '请输入姓名',
                  },
                ],
              },
            ]"
            placeholder="姓名"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="登录密码">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: !account,
                    message: '请输入密码',
                  },
                  {
                    pattern: passwordExp,
                    message: '密码需要大于9位，包含英文大小写、数字、特殊字符'
                  }
                ],
              },
            ]"
            type="password"
            placeholder="登录密码"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="确认密码">
          <a-input
            v-decorator="[
              'confirmPwd',
              {
                rules: [
                  {
                    validator: confirmPwdValidator,
                  },
                ],
              },
            ]"
            type="password"
            placeholder="请再次输入密码"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item label="企业微信企业id">
          <a-input
            v-decorator="[
              'corpId',
              {
                initialValue: account ? accountDetail.corpId : undefined,
              },
            ]"
            placeholder="企业微信企业id"
            autocomplete="off"
          />
        </a-form-item>
        <a-form-item
          label="企业微信账号"
          extra="通过绑定企业微信账号，使该平台和企业微信账号互通！"
        >
          <a-input
            v-decorator="[
              'corpUserId',
              {
                initialValue: account ? accountDetail.corpUserId : undefined,
              },
            ]"
            placeholder="请输入企业微信账号"
            autocomplete="off"
          />
        </a-form-item>
        <template>
          <template>
            <a-form-item label="角色">
              <a-select
                v-decorator="[
                  `accountProducts[${Product.BRAND}][roleId]`,
                  {
                    initialValue: account ? account && accountDetail.roleId : undefined,
                    rules: [
                      {
                        required: true,
                        message: '请选择',
                      },
                    ],
                  },
                ]"
                placeholder="请选择"
              >
                <a-select-option
                  v-for="role in roleMap[Product.BRAND]"
                  :key="role.id"
                >{{
                  role.roleName
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="数据权限">
              <a-radio-group
                v-decorator="[
                  `accountProducts[${Product.BRAND}][accountType]`,
                  {
                    preserve: true,
                    initialValue: account ? account && accountDetail.accountType : 'MERCHANT',
                    rules: [
                      {
                        required: true,
                        message: '请选择',
                      },
                    ],
                  },
                ]"
              >
                <a-radio
                  v-for="perm in DataPermByProduct[Product.BRAND]"
                  :key="perm"
                  :value="perm"
                >{{ DataPermText[perm] }}</a-radio>
              </a-radio-group>
            </a-form-item>
            <template
              v-if="
                form.getFieldValue(`accountProducts[${Product.BRAND}][accountType]`) ===
                  DataPerm.STORE
              "
            >
              <a-form-item label="选择门店">
                <a-select
                  v-decorator="[
                    `accountProducts[${Product.BRAND}][storeId]`,
                    {
                      initialValue: account ? account && Number([accountDetail.storeIds]) : undefined,
                      rules: [
                        {
                          required: true,
                          message: '请选择',
                        },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  option-filter-prop="children"
                  show-search
                  @search="textSearch"
                  @popupScroll="storeSelectScroll"
                  @dropdownVisibleChange="storeDropdownVisibleChange"
                  @select="storeSelect"
                >
                  <a-select-option
                    v-for="store in storeMap[Product.BRAND]"
                    :key="store.id"
                  >{{ store.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </template>
          </template>
        </template>
      </template>
    </a-form>
    <div class="account__edit__action-list">
      <a-button
        @click="handleCancel"
        class="account__edit__action"
      >取消</a-button>
      <a-button
        type="primary"
        @click="handleOk"
        class="account__edit__action"
      >提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { TreeSelect } from 'ant-design-vue';
import { mapState } from 'vuex';
import GroupTile from '@/components/group-title';
import Transfer from '@/components/Transfer';
import { changeArray } from '@/utils/helpers';
import { passwordExp } from '@/consts';

import {
  Product, ProductText, DataPerm, DataPermText, DataPermByProduct,
} from '@/consts/product';


export default {
  components: {
    GroupTile,
    Transfer,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    account: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      passwordExp,
      form: this.$form.createForm(this, { name: 'account_edit' }),
      Product,
      ProductText,
      DataPerm,
      DataPermText,
      DataPermByProduct,
      // storeVisible: false,
      SHOW_PARENT: TreeSelect.SHOW_PARENT,
      otherTypeShow: false,
      // modelStoreIds: [], // 模态框中的已经选择的门店
      storeParamObj: {
        formatId: [],
        cityList: [],
      },
      storeSelectInfo: {
        pageNo: 1,
        pageSize: 100,
        name: '',
      },
    };
  },
  computed: {
    ...mapState('role', ['roleMap']),
    ...mapState('user', ['userInfo']),
    ...mapState('account', ['accountDetail', 'formatIdList', 'cityList', 'storeList']),
    ...mapState('store', ['storeMap']),
    productMap() {
      return this.userInfo.appProductIdList.reduce((acc, productId) => {
        let product;

        if (this.accountDetail) {
          product = (this.accountDetail.accountProducts || []).find(
            ({ productId: pid }) => pid === productId,
          );
        }
        return {
          ...acc,
          [productId]: product || {},
        };
      }, {});
    },
  },
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const { confirmPwd, accountProducts, ...payload } = values;
          const params = accountProducts[Product.BRAND];
          this.$emit('ok', { ...payload, ...params });
        }
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
    confirmPwdValidator(_, value) {
      const { getFieldValue } = this.form;
      const password = getFieldValue('password');

      if (password && !value) {
        return new Error('请再次输入登录密码');
      }

      if (value !== password) {
        return new Error('两次输入的密码不一致');
      }

      return true;
    },
    singleSelectNormalizer(val = [], prevVal = []) {
      if (val.length > prevVal.length) {
        return val.slice(-1);
      }
      return val;
    },
    // setStore() {
    //   this.storeVisible = true;
    //   this.$store.dispatch('account/fetchStoreList', this.storeParamObj);
    // },
    resetStore() {
      this.form.setFieldsValue({ [`accountProducts[${Product.BRAND}][storeId]`]: [] });
      this.$store.dispatch('account/fetchStoreList', this.storeParamObj);
    },
    handleFormatIdsChange(val) {
      this.storeParamObj = {
        ...this.storeParamObj,
        formatId: val,
      };
      // this.modelStoreIds = [];
      // this.$store.dispatch('account/fetchStoreList', this.storeParamObj);
      this.resetStore();
    },
    handleRegionIdsChange(val) {
      const provinceList = val;
      const cityList = changeArray(provinceList, this.cityList);
      this.storeParamObj = {
        ...this.storeParamObj,
        cityList,
      };
      // this.modelStoreIds = [];
      // this.$store.dispatch('account/fetchStoreList', this.storeParamObj);
      this.resetStore();
    },
    // handleStoreOk() {
    //   this.storeVisible = false;
    // },
    // handleStoreCancel() {
    //   this.storeVisible = false;
    // },
    dataLimitChange(e) {
      const val = e.target.value;
      this.otherTypeShow = val === 'OTHER';
    },
    // handleStore(val) {
    //   this.modelStoreIds = val;
    // },
    textSearch(name) {
      const { dispatch } = this.$store;
      this.storeSelectInfo.pageNo = 1;
      this.storeSelectInfo.name = name;
      dispatch('store/fetchListByProduct', {
        productId: 3,
        pageNo: this.storeSelectInfo.pageNo,
        pageSize: this.storeSelectInfo.pageSize,
        name,
      });
    },
    storeSelectScroll(ev) {
      const { dispatch } = this.$store;
      if (ev.target.scrollTop >= (this.storeMap[Product.BRAND].length - 5) * 30) {
        if (this.storeMap[Product.BRAND].length >= this.storeSelectInfo.pageNo * this.storeSelectInfo.pageSize) {
          this.storeSelectInfo.pageNo += 1;
          dispatch('store/fetchListByProduct', {
            productId: 3,
            pageNo: this.storeSelectInfo.pageNo,
            pageSize: this.storeSelectInfo.pageSize,
            name: this.storeSelectInfo.name,
          });
        }
      }
    },
    storeDropdownVisibleChange(visible) {
      const { dispatch } = this.$store;
      if (visible) {
        this.storeSelectInfo.pageNo = 1;
        dispatch('store/fetchListByProduct', {
          productId: 3,
          pageNo: this.storeSelectInfo.pageNo,
          pageSize: this.storeSelectInfo.pageSize,
          // name: this.storeSelectInfo.name,
        });
      }
    },
  },
  created() {
    const { dispatch } = this.$store;
    const { account } = this;
    // const { setFieldsValue } = this.form;
    dispatch('role/fetchListByProduct', { productId: 3 });
    dispatch('store/fetchListByProduct', {
      productId: 3,
      pageNo: this.storeSelectInfo.pageNo,
      pageSize: this.storeSelectInfo.pageSize,
      name: this.storeSelectInfo.name,
      storeIds: account.storeIds,
      storeName: account.storeName,
    });

    if (account) {
      setTimeout(() => {
        dispatch('account/fetchDetail', account);
      }, 100);
      // dispatch('account/fetchDetail', { id: account.id }).then(() => {
      //   const {
      //     dataLimit,
      //     regionIds,
      //     formatIds,
      //     // storeIds,
      //   } = this.productMap[Product.YUNCHA];
      //   this.dataLimitChange({ target: { value: dataLimit } });
      //   this.storeParamObj = {
      //     formatId: formatIds,
      //     cityList: regionIds,
      //   };
      //   // this.modelStoreIds = storeIds;
      //   dispatch('account/fetchStoreList', this.storeParamObj);
      //   for (const [productId, product] of Object.entries(this.productMap)) {
      //     if (!isEmpty(product)) {
      //       setTimeout(() => {
      //         setFieldsValue({ [`accountProducts[${productId}][openStatus]`]: true });
      //       }, 0); // vue的生命周期执行和组件initvalue会存在时序问题。导致在getFieldValue的时候值不是期望的值
      //       setTimeout(() => {
      //         setFieldsValue({
      //           [`accountProducts[${productId}][functionType]`]: product.functionType,
      //         });
      //       }, 1); // 有时序问题openStatus要在functionType之前被设置
      //     }
      //   }
      // });
    }
  },
};
</script>

<style lang="less" scoped>
.account__edit {
  &__form {
    padding-bottom: 80px;
  }
  &__action {
    &-list {
      position: absolute;
      z-index: 3;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      padding: 10px 16px;
      border-top: 1px solid var(--border-color-split);
      text-align: right;
      background-color: var(--main-bg);
    }
  }
  .other {
    margin-left: 25%;
  }
  .flex {
    display: flex;
  }
  .fields_name {
    width: 23%;
    text-align: right;
  }
  .fields_detail {
    flex: 1;
  }
  .store {
    width: 23%;
    text-align: right;
  }
}
</style>
